import { BaseProps } from './shared'

export function Adjustment() {
	return {
		...BaseProps('OPEN'),
		referenceId: null,
		shop: null,
		device: null,
		products: [],
	}
}

export function AdjustmentShop(shop) {
	return {
		id: shop.id,
		code: shop.code,
		name: shop.name,
	}
}

export function AdjustmentDevice(device) {
	return {
		id: device.id,
		name: device.name,
	}
}

export function AdjustmentProduct(product, units, quantity) {
	return {
		id: product.id,
		name: product.name,
		units,
		defaultUnit: product.defaultUnit,
		quantity,
	}
}
